import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { clientWellness } from "../../App";
import ListOfMySpaces from "../../components/ListOfMySpaces/ListOfMySpaces";
import SpaceManagerTabs from "../../components/SpaceManagerTabs/SpaceManagerTabs";
import {
  ALL_MY_SPACES_MANAGEMENT,
  ALL_MY_SPACES_MANAGEMENT_AFTER,
  ALL_MY_SPACES_MANAGEMENT_BEFORE,
} from "../../GraphQL/Queries";
import YammerContainer from "../YammerContainer/YammerContainer";
import { GeneralStyle } from "./SpacesManagementContainer.styled";
import { useHistory, useLocation } from "react-router-dom";
import { UPDATE_SPACE_STATUS } from "../../GraphQL/Mutations";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { NotificationManager } from "react-notifications";
import { ReactComponent as EngagementIcon } from "../../assets/svg/engagement-header-icon.svg";
import HeaderComponent from "../../components/Header/Header";

const SpacesManagementContainer = () => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [myspaces, setMySpaces] = useState([]);
  const [myspace, setMySpace] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [selectedMenu, selectMenu] = useState(["myspaces", "My Spaces"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const [renderAgain, setrenderAgain] = useState(false);
  const [updateSpaceStatus] = useMutation(UPDATE_SPACE_STATUS, {
    client: clientWellness,
  });
  const location = useLocation();
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const [filterData, setFilterData] = useState({});

  const [
    runQueryAllMySpacesManagement,
    { loading: loadingMySpaces, error: errorMySpaces },
  ] = useLazyQuery(ALL_MY_SPACES_MANAGEMENT, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  const [
    runQueryAllMySpacesManagementAfter,
    { loading: loadingMySpacesAfter, error: errorMySpacesAfter },
  ] = useLazyQuery(ALL_MY_SPACES_MANAGEMENT_AFTER, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  const [
    runQueryAllMySpacesManagementBefore,
    { loading: loadingMySpacesBefore, error: errorMySpacesBefore },
  ] = useLazyQuery(ALL_MY_SPACES_MANAGEMENT_BEFORE, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  useEffect(() => {
    if (location?.topBanner) {
      let config = JSON.parse(location.topBanner);
    }
  }, [location]);

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    } else if (formTrigger === selectedMenu[0]) {
      setFormTrigger(selectedMenu[0]);
    }
    if (formTrigger === "myspace") {
      setTimeout(() => {
        history.push({ pathname: "/CreateSpace" });
      }, 0);
    } else if (formTrigger === "editmyspace" && myspace) {
      setTimeout(() => {
        history.push({ pathname: "/CreateSpace", state: { myspace: myspace } });
      }, 0);
    }
  }, [formTrigger, myspace, selectedMenu]);

  useEffect(() => {
    runQueryAllMySpacesManagement({
      variables: {
        first: rowsPerPage,
      },
    });
  }, [rowsPerPage, renderAgain]);

  const asignData = (data) => {
    setAllPages(data?.spacesAdministration?.totalCount);
    if (data?.spacesAdministration?.pageInfo?.hasNextPage === true) {
      setEndCursor(data?.spacesAdministration?.pageInfo?.endCursor);
    }
    if (data?.spacesAdministration?.pageInfo?.hasPreviousPage === true) {
      setStartCursor(data?.spacesAdministration?.pageInfo?.startCursor);
    }
    let allSpaces = data?.spacesAdministration?.edges.map((space) => {
      return {
        idSpace: space.node.idSpace,
        name: space.node.name,
        topic: space.node.topic,
        countryName: space.node.countryName,
        cityName: space.node.cityName,
        createUser: space.node.createUser,
        recordState: space.node.recordState,
      };
    });
    setMySpaces(allSpaces);
  };

  let handleClickActions = (space, rowData) => {
    setAnchorEl(space.currentTarget);
    setAnchorSelected(rowData.idSpace);
  };

  let handleEditSpace = (rowData) => {
    setMySpace(rowData);
    setAnchorEl(null);
    setAnchorSelected(null);
    setFormTrigger("editmyspace");
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      runQueryAllMySpacesManagementAfter({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          searchBy: filterData.name ? filterData.name : "",
          countryId: filterData.country ? filterData.country : null,
          cityId: filterData.city ? filterData.city : null,
        },
      });
    }
    if (newPage < page) {
      runQueryAllMySpacesManagementBefore({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          searchBy: filterData.name ? filterData.name : "",
          countryId: filterData.country ? filterData.country : null,
          cityId: filterData.city ? filterData.city : null,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event, dataFilter) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 10);
    setPage(0);
    setFilterData(dataFilter);
    runQueryAllMySpacesManagement({
      variables: {
        first: event.target.value ? parseInt(event.target.value) : 10,
        searchBy: dataFilter.name ? dataFilter.name : "",
        countryId: dataFilter.country ? dataFilter.country : null,
        cityId: dataFilter.city ? dataFilter.city : null,
      },
    });
  };

  let updateMySpaceState = (rowData, state) => {
    let newState = state.toUpperCase();
    updateSpaceStatus({
      variables: {
        eventid: rowData.idSpace,
        newState: newState,
      },
    })
      .then((response) => {
        if (response.errors) {
          NotificationManager.warning(response.errors[0].message, "", 5000);
        } else {
          if (response.data.updateSpaceStatus.idSpace) {
            if (state === "Deleted") {
              myspaces.splice(
                myspaces.findIndex((f) => f.idSpace === rowData.idSpace),
                1
              );
              setrenderAgain(!renderAgain);
            }
          }
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let toggleChecked = (rowData, state) => {
    updateMySpaceState(rowData, state);
  };

  let deleteMySpace = (rowData) => {
    updateMySpaceState(rowData, "Deleted");
    setOpenDeleteModal(null);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this space?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteMySpace}
      />
    ) : null;
  };

  const showSelectedMenuTable = (selectedMenu) => {
    switch (selectedMenu[0]) {
      case "myspaces":
        return (
          <ListOfMySpaces
            loadingMySpaces={loadingMySpaces}
            loadingMySpacesAfter={loadingMySpacesAfter}
            loadingMySpacesBefore={loadingMySpacesBefore}
            errorMySpaces={errorMySpaces}
            errorMySpacesAfter={errorMySpacesAfter}
            errorMySpacesBefore={errorMySpacesBefore}
            myspaces={myspaces}
            toggleChecked={toggleChecked}
            handleClickActions={handleClickActions}
            anchorEl={anchorEl}
            anchorSelected={anchorSelected}
            handleCloseActions={handleCloseActions}
            handleEditSpace={handleEditSpace}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            allPages={allPages}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            runQueryAllMySpacesManagement={runQueryAllMySpacesManagement}
          />
        );
      case "yammer":
        return <YammerContainer />;
      default:
        break;
    }
  };

  return (
    <GeneralStyle>
      <HeaderComponent Icon={EngagementIcon} text={"Engagement"} />
      <SpaceManagerTabs
        selectedMenu={selectedMenu}
        selectMenu={selectMenu}
        setFormTrigger={setFormTrigger}
        setValueTabs={setValueTabs}
        valueTabs={valueTabs}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      {showSelectedMenuTable(selectedMenu)}
      {showDeleteModal()}
    </GeneralStyle>
  );
};

export default SpacesManagementContainer;
